import dayjs from 'dayjs'
import query from './query'
const formatTitle = () => {
    const startTime = query('startTime')
    const endTime = query('endTime')
    const type = query('type')
    let d = 'YYYY年MM月DD日'
    let title:any = ''
    /**
     * title 0:今日 1:昨日 2:本周 3:本月 4:本年 5:自定义
     */
    switch (type) {
        case '0':
            title = dayjs(startTime).format(d)
            break
        case '1':
            title = dayjs(startTime).format(d)
            break
        case '2':
            d = 'MM月DD日'
            title = `${dayjs(startTime).format(d)}~${dayjs(endTime).format(d)}`
            break
        case '3':
            d = 'YYYY年MM月'
            title = `${dayjs(startTime).format(d)}`
            break
        case '4':
            d = 'YYYY年'
            title = `${dayjs(startTime).format(d)}`
            break
        case '5':
            d = 'MM月DD日'
            title = `${dayjs(startTime).format(d)}~${dayjs(endTime).format(d)}`
            break
        default:
    }
    let options: any = {
        startTime: query('startTime'),
        endTime: query('endTime') || query('startTime')
    }
    return {
        title,
        options
    }
}
export default formatTitle